import QRCode from "qrcode";
import { useEffect, useState } from "react";

/** On a phone, the one-tap link; elsewhere, the QR code to scan with one. */
const onPhone = () => typeof window !== "undefined" && window.matchMedia("(pointer: coarse)").matches;

/**
 * Setting up sign-in codes: one tap on the phone being used (iPhone's Passwords app keeps the codes;
 * Android opens an authenticator app), or a QR code to scan with a phone, or the key typed in.
 */
export function AuthenticatorSetup({ secret, uri }: { secret: string; uri: string }) {
  const [qr, setQr] = useState<string | null>(null);
  const phone = onPhone();
  useEffect(() => {
    QRCode.toDataURL(uri, { margin: 1, width: 200, color: { dark: "#1F1A1C", light: "#FFFFFF" } }).then(setQr, () => setQr(null));
  }, [uri]);
  return (
    <div className="flex flex-col gap-3 text-sm">
      <ul className="flex flex-col gap-1 text-ink-soft">
        <li>
          <span className="font-semibold text-ink">iPhone:</span> nothing to install. {phone ? "Tap the button below" : "Point your camera at the code"} and choose to add it to Passwords.
        </li>
        <li>
          <span className="font-semibold text-ink">Android:</span> install <span className="font-medium">Google Authenticator</span> from the Play Store first, then {phone ? "tap the button below" : "scan the code with it"}.
        </li>
      </ul>
      {phone && (
        <a href={uri} className="inline-flex items-center justify-center rounded-[var(--radius-control)] bg-brand px-4 py-2.5 text-[15px] font-semibold text-white hover:bg-brand-deep">
          Set up on this phone
        </a>
      )}
      <div className="flex items-center gap-4 rounded-[var(--radius-panel)] border border-line bg-white p-4">
        {!phone && (qr ? <img src={qr} alt="QR code for your phone's code generator" className="size-32" /> : <div className="size-32 bg-mist" />)}
        <div className="min-w-0">
          <p className="font-semibold">{phone ? "Button didn't work?" : "Can't scan?"}</p>
          <p className="mt-1 text-muted">Add a code by hand and enter this key:</p>
          <p className="mt-1 break-all font-medium select-all">{secret}</p>
        </div>
      </div>
      <p className="text-ink-soft">Then enter the 6-digit code it shows. After this, you'll usually sign in with Face ID or your fingerprint instead.</p>
    </div>
  );
}
